import { render, staticRenderFns } from "./DepartamentosCadastro.vue?vue&type=template&id=1f265deb&"
import script from "./DepartamentosCadastro.vue?vue&type=script&lang=js&"
export * from "./DepartamentosCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports